import { createContext, useContext } from "react";

export interface ScannerCounts {
  orderToteMapping: number;
  inward: number;
  cycleCount: number;
}

export interface AppData {
  configName?: string;
  counts: ScannerCounts;
  /** True when an inward orchestration is running (drives the "exit inward" cue). */
  inwardOrchestrationActive: boolean;
  accountName?: string;
  authEnabled: boolean;
  signOut: () => void;
}

const AppDataContext = createContext<AppData | null>(null);

export const AppDataProvider = AppDataContext.Provider;

export function useAppData(): AppData {
  const value = useContext(AppDataContext);
  if (!value) {
    throw new Error("useAppData must be used within an AppDataProvider");
  }
  return value;
}
